import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';

import { cn } from '@/utils/cn';

const LINKS = [
  { to: '/pastoral/visits', end: false, labelKey: 'nav.visits' as const },
  { to: '/pastoral/counseling', end: false, labelKey: 'nav.counseling' as const },
  { to: '/pastoral/appointments', end: false, labelKey: 'nav.appointments' as const },
];

export const PastoralSubnav = () => {
  const { t } = useTranslation('pastoral');

  return (
    <nav className="mb-4 flex flex-wrap gap-2" aria-label={t('title')}>
      {LINKS.map((link) => (
        <NavLink
          key={link.to}
          to={link.to}
          end={link.end}
          className={({ isActive }) =>
            cn(
              'rounded-md px-3 py-1.5 text-body-sm',
              isActive
                ? 'bg-brand/10 font-medium text-brand'
                : 'text-fg-secondary hover:bg-surface-muted hover:text-fg',
            )
          }
        >
          {t(link.labelKey)}
        </NavLink>
      ))}
    </nav>
  );
};
